module.exports = __webpack_public_path__ + "img/zgsh.7ad4dc80.jpg";